const qs = require( 'querystring' )

function getPath( { path, value }, pathArr ) {
  if ( typeof pathArr === 'string' ) {
    if ( path === 0 ) {
      return value
    }
    const toReturn = new Array( path + 1 )
    toReturn[0] = pathArr
    toReturn[path] = value
    return condense( toReturn )
  }

  const toReturn = [ ...pathArr ]
  if ( path >= pathArr.length ) {
    toReturn.length = path + 1
  }
  toReturn[path] = value
  
  return condense( toReturn )
}

function condense( pathArr ) {
  if ( typeof pathArr === 'string' ) {
    return pathArr
  }
  let flag = false
  for ( let i = 1; i < pathArr.length; i++ ) {
    if ( pathArr[i] ) {
      flag = true
    }
  }
  if ( !flag ) {
    return pathArr[0]
  }
  return pathArr
}

function syncQueryToLocation( query, location ) {
  const { search } = location

  let searchObj = { q : JSON.stringify( query ) }
  if ( search ) {
    searchObj = { ...qs.parse( search.slice( 1 ) ), ...searchObj }
  }
  return `${location.pathname}?${qs.stringify( searchObj )}`
}

exports.getPath = getPath
exports.syncQueryToLocation = syncQueryToLocation
